import { render, staticRenderFns } from "./CitySkill.vue?vue&type=template&id=2b66ce1d&scoped=true&"
import script from "./CitySkill.vue?vue&type=script&lang=js&"
export * from "./CitySkill.vue?vue&type=script&lang=js&"
import style0 from "./CitySkill.vue?vue&type=style&index=0&id=2b66ce1d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b66ce1d",
  null
  
)

export default component.exports